/**
 * A loading indicator that shows a growing, striped bar in Sharpen brand
 * colors. The animation takes 12 seconds to complete.
 */
export default {
  title: 'Atoms/Waiting Bar',
  tags: ['autodocs'],
  render: () => `<sharpen-waiting-bar></sharpen-waiting-bar>`,
};

export const Example = {};
